import { render } from "./SavedPersonalDataFiles.vue?vue&type=template&id=0bd3f06e"
import script from "./SavedPersonalDataFiles.vue?vue&type=script&lang=js"
export * from "./SavedPersonalDataFiles.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__